import styled from 'styled-components';

export const Container = styled.div`
  width: 85%;
  max-width: 100rem;
  display: flex;
  border-radius: 15px;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.background_white};

  @media (max-width: 900px) {
    width: -webkit-fill-available;
    margin: 0 1.5rem;
  }

  @media (max-width: 320px) {
    margin: 0 0.5rem;
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  h1 {
    font-size: 1.9rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary};
  }
  span {
    color: ${({ theme }) => theme.colors.primary};
  }
  p {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.text};
  }
`;
